import request from "../../Utils/curl"

let degreeCourses = {
  /**
   * degreeCourse List
   */
  async degreeCourseList (context, whereFilter = null) {
    try {
      let postData = new FormData()
      if (whereFilter) {
        postData.append("filter", JSON.stringify(whereFilter))
      }

      return await request.curl(context, "degree_course_list", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at degreeCourseList() and Exception:", err.message)
    }
  },

  /**
   * degreeCourse View
   */
  async degreeCourseView (context, degreeCourseId) {
    try {
      let postData = new FormData()
      postData.append("dc_id", degreeCourseId)

      return await request.curl(context, "degree_course_view", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at degreeCourseView() and Exception:", err.message)
    }
  },

  /**
   * degreeCourse Add
   */
  async degreeCourseAdd (context, degreeCourseObj) {
    try {
      let postData = new FormData()
      for (let key in degreeCourseObj) {
        postData.append(key, degreeCourseObj[key])
      }

      return await request.curl(context, "degree_course_add", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at degreeCourseAdd() and Exception:", err.message)
    }
  },

  /**
   * degreeCourse Edit
   */
  async degreeCourseEdit (context, degreeCourseObj) {
    try {
      let postData = new FormData()
      for (let key in degreeCourseObj) {
        postData.append(key, degreeCourseObj[key])
      }

      return await request.curl(context, "degree_course_edit", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at degreeCourseEdit() and Exception:", err.message)
    }
  },

  /**
   * degreeCourse Delete
   */
  async degreeCourseDelete (context, degreeCourseId) {
    try {
      let postData = new FormData()
      postData.append("dc_id", degreeCourseId)

      return await request.curl(context, "degree_course_delete", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.log("Exception occurred at degreeCourseDelete() and Exception:", err.message)
    }
  },

  /**
   * degreeCourse FilterList
   */
  async degreeCourseFilterList (context, filterName = "") {
    try {
      if (!filterName) {
        return
      }

      let postData = new FormData()
      postData.append("filter_name", filterName)

      return await request.curl(context, "degree_course_filter_list", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at degree_course_filter_list() and Exception:", err.message)
    }
  }
}

export {
  degreeCourses
}
